<app-titulo [inputTitulo]="'BUZON DE SUGERENCIAS'" [inputSubtitulo]="'¿Tienes alguna queja o sugerencia? Por favor, describela a continuación'"></app-titulo>

<div class="CExpandir">
    <iframe id="iframeTufES" class="CExpandir" [src]="url" frameBorder="0"></iframe>
</div>